import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import SuperAdminStorageService from "../services/SuperAdminStorageService";

const TOKEN_COOKIE = "auth_token";

export default function ProtectedRoute({ children }) {
  if (SuperAdminStorageService.isAuthenticated()) {
    return <Navigate to="/super-admin/dashboard" replace />;
  }

  const token = Cookies.get(TOKEN_COOKIE);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
